import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

// routes
import MainRoutes from './MainRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';

// project imports
import config from './../configs';
import { getAccessToken } from '../services/authService';

const AUTH_PATHS = ['/session/login', '/session/register', '/verify-email', '/forgot-password', '/reset-password'];

//-----------------------|| ROUTING RENDER ||-----------------------//
// Switch only first-matches direct <Route>/<Redirect> children. Wrapping AuthRoutes
// and MainRoutes in a Fragment broke that exclusivity and rendered both trees at
// once, so an authenticated user could land on /session/login. Each branch is now
// a real Route child of Switch; the catch-all at the end falls through to MainRoutes.
const Routes = () => {
    return (
        <Switch>
            {/* An authenticated visitor to the bare root should land on the dashboard, not
                back at the login form — config.defaultPath is only the pre-login target. */}
            <Redirect exact from="/" to={getAccessToken() ? '/dashboard' : config.defaultPath} />
            <Route path={AUTH_PATHS}>
                <AuthenticationRoutes />
            </Route>
            <Route>
                <MainRoutes />
            </Route>
        </Switch>
    );
};

export default Routes;
